/** Сезон в состоянии игрока. */
import { Coins, PosInt, UInt, UnixMs } from "../../common";
import { z } from "zod";

/** Сезон игрока: цели и награды шагов считает engine (`seasonSteps`), здесь только то, что знает сервер. */
export const SeasonState = z.object({
  /** Номер сезона, с 1. */
  number: PosInt,
  endsAt: UnixMs,
  /** Очки сезона: только за действия, пропуск их не меняет. */
  points: UInt,
  /** Очки за сегодня, не больше дневного потолка. */
  todayPoints: UInt,
  /** Забрано на бесплатной дорожке и на дорожке пропуска: все шаги до этого номера. */
  claimedFree: UInt,
  claimedPass: UInt,
  /** Пропуск куплен на этот сезон. */
  pass: z.boolean(),
});
export type SeasonState = z.infer<typeof SeasonState>;

/** Что даёт шаг сезона или всё забранное разом. */
export const SeasonReward = z.object({ coins: Coins, crystals: UInt, skip: UInt, speed: UInt });
export type SeasonReward = z.infer<typeof SeasonReward>;

/** Поля {@link PlayerState}. */
export const seasonFields = {
  /** Сезон; `null` — сезона нет в данных баланса. Без поля (старый сервер во время выката) — тоже `null`. */
  season: SeasonState.nullable().default(null),
  /** Кристаллы: только из наград сезона и лиги, тратятся в обмене. */
  crystals: UInt.default(0),
  /** Снятия таймера и часы x2 с дорожки пропуска. */
  skipTickets: UInt.default(0),
  speedTickets: UInt.default(0),
  /** До какого момента открыта скорость x2 без VIP; `null` — не открыта. */
  speedUntil: UnixMs.nullable().default(null),
};
